<template>
  <Modal
    v-if="confirmStore.isOpen && confirmStore.props"
    :title="confirmStore.props?.title"
    :description="confirmStore.props?.description"
    :open="confirmStore.isOpen"
    :hide-close-icon="confirmStore.props?.hideCloseIcon"
    :max-width="confirmStore.props?.maxWidth"
    :min-width="confirmStore.props?.minWidth"
    :z-index="confirmZIndex"
    :size="confirmStore.props?.size ?? 'l'"
    @update:open="onClose"
  >
    <template #actions>
      <div class="actions">
        <BaseButton
          :full="confirmStore.props.buttonFullWidth ?? true"
          type="primary"
          size="xxl"
          @click="onConfirm()"
        >
          {{ confirmStore.props?.confirmButtonText || 'Подтвердить' }}
        </BaseButton>
        <BaseButton
          v-if="confirmStore.props?.cancelButtonText !== null"
          :full="confirmStore.props.buttonFullWidth ?? true"
          type="secondary"
          size="xxl"
          @click="onClose(false)"
        >
          {{ confirmStore.props?.cancelButtonText || 'Отмена' }}
        </BaseButton>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { BaseButton } from 'src/shared/ui/base-button';

import { useConfirmStore } from './model';
import { Modal } from '../modal';

const confirmStore = useConfirmStore();

// Confirmations can be opened from another modal. Keep them above the base
// modal, dropdown and nested-dialog layers even when legacy callers pass a lower z-index.
const confirmZIndex = computed(() => Math.max(confirmStore.props?.zIndex ?? 70, 70));

const onConfirm = (): void => {
  confirmStore.onClose(true);
};

const onClose = (value: boolean): void => {
  if (!value) {
    confirmStore.onClose(false);
  }
};
</script>
<style scoped>
.actions {
  width: 100%;
  display: flex;
  gap: var(--spacing-2xl);
  justify-content: center;
}

.spinner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 250px;
  min-width: 250px;
  width: 100%;
  height: 100%;
}

@media (width <= 755px) {
  .actions {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
